module.exports = __webpack_public_path__ + "img/egt.62b1c81c.svg";